
const metadata = {
  'ST-50x70-WHI': {
    key: 'ST-50x70-WHI',
    type: 'frame',
    name: 'Frame White',
    variant: 'white',
    descriptions: {
      sv: 'Svensktillverkad träram som passar till våra samtliga födelsetavlor i storleken 50x70 cm.',
      en: 'Wooden frame with acrylic glass that fits perfectly with our 50x70 cm birth posters. Made in Sweden.'
    },
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/ST-50x70-WHI.png',
    dimensions: '50x70',
    brand: 'Born This Day',
    prices: {
      SEK: 29000,
      DKK: 22000,
      EUR: 3500,
      USD: 3900,
      AUD: 5700
    }
  },
  'ST-50x70-BLA': {
    key: 'ST-50x70-BLA',
    type: 'frame',
    name: 'Frame Black',
    variant: 'black',
    descriptions: {
      sv: 'Svensktillverkad träram som passar till våra samtliga födelsetavlor i storleken 50x70 cm.',
      en: 'Wooden frame with acrylic glass that fits perfectly with our 50x70 cm birth posters. Made in Sweden.'
    },
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/ST-50x70-BLA.png',
    dimensions: '50x70',
    brand: 'Born This Day',
    prices: {
      SEK: 29000,
      DKK: 22000,
      EUR: 3500,
      USD: 3900,
      AUD: 5700
    }
  },
  'ST-50x70-OAK': {
    key: 'ST-50x70-OAK',
    type: 'frame',
    name: 'Frame Oak',
    variant: 'oak',
    descriptions: {
      sv: 'Svensktillverkad träram som passar till våra samtliga födelsetavlor i storleken 50x70 cm.',
      en: 'Wooden frame with acrylic glass that fits perfectly with our 50x70 cm birth posters. Made in Sweden.'
    },
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/ST-50x70-OAK.png',
    dimensions: '50x70',
    brand: 'Born This Day',
    prices: {
      SEK: 29000,
      DKK: 22000,
      EUR: 3500,
      USD: 3900,
      AUD: 5700
    }
  },
  'LIST-50-WHI': {
    key: 'LIST-50-WHI',
    type: 'hanger',
    name: 'Hanger White',
    variant: 'white',
    descriptions: {
      sv: 'Posterhängare där födelsetavlan enkelt fästs mellan listerna med hjälp av magneter, utan att förstöra pappret.',
      en: 'Post hangers where the birth poster is easily attached between magnetic components, without damaging the paper.'
    },
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/LIST-50-WHI.png',
    dimensions: '50x70',
    brand: 'Born This Day',
    prices: {
      SEK: 19000,
      DKK: 15000,
      EUR: 1900,
      USD: 2300,
      AUD: 3100
    }
  },
  'LIST-50-BLK': {
    key: 'LIST-50-BLK',
    type: 'hanger',
    name: 'Hanger Black',
    variant: 'black',
    descriptions: {
      sv: 'Posterhängare där födelsetavlan enkelt fästs mellan listerna med hjälp av magneter, utan att förstöra pappret.',
      en: 'Post hangers where the birth poster is easily attached between magnetic components, without damaging the paper.'
    },
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/LIST-50-BLK.png',
    dimensions: '50x70',
    brand: 'Born This Day',
    prices: {
      SEK: 19000,
      DKK: 15000,
      EUR: 1900,
      USD: 2300,
      AUD: 3100
    }
  },
  'LIST-50-OAK': {
    key: 'LIST-50-OAK',
    type: 'hanger',
    name: 'Hanger Oak',
    descriptions: {
      sv: 'Posterhängare där födelsetavlan enkelt fästs mellan listerna med hjälp av magneter, utan att förstöra pappret.',
      en: 'Post hangers where the birth poster is easily attached between magnetic components, without damaging the paper.'
    },
    url: 'https://s3.eu-central-1.amazonaws.com/bornthisday/products/LIST-50-OAK.png',
    dimensions: '50x70',
    brand: 'Born This Day',
    variant: 'oak',
    prices: {
      SEK: 19000,
      DKK: 15000,
      EUR: 1900,
      USD: 2300,
      AUD: 3100
    }
  }
}

export default {
  strict: true,

  state: {
    framesDialogIsShowing: false
  },

  mutations: {
    SHOW_FRAMES_DIALOG (state, showFramesDialog) {
      state.framesDialogIsShowing = showFramesDialog
    }
  },

  actions: {
    showFramesDialog ({ commit, dispatch }, showFramesDialog) {
      commit('SHOW_BACKDROP', true)
      commit('SHOW_FRAMES_DIALOG', showFramesDialog)
    }
  },

  getters: {
    productsMetadata () {
      return JSON.parse(JSON.stringify(metadata))
    },
    framesDialogIsShowing (state) {
      return state.framesDialogIsShowing
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/products.js